document.addEventListener("DOMContentLoaded", function (event) {
  const expertsSlider = document.querySelector("#expertsSlider");

  if (expertsSlider) {
    const swiper = new Swiper("#expertsSlider", {
      slidesPerView: 2,
      spaceBetween: 15,
      navigation: {
        nextEl: "#expertsNextBtn",
        prevEl: "#expertsPrevBtn",
      },
      breakpoints: {
        767: {
          slidesPerView: 6,
        },
      },
    });
  }

  // о нас эксперты
  if (document.querySelector("#aboutExpertsSlider")) {
    const swiper = new Swiper("#aboutExpertsSlider", {
      slidesPerView: 1,
      spaceBetween: 30,
      navigation: {
        nextEl: "#aboutExpertsNext",
        prevEl: "#aboutExpertsPrev",
      },
      breakpoints: {
        767: {
          slidesPerView: 2,
        },
      },
    });
  }

  // о нас прогнозисты
  if (document.querySelector("#aboutForecastsSlider")) {
    const swiper = new Swiper("#aboutForecastsSlider", {
      slidesPerView: 1,
      spaceBetween: 30,
      navigation: {
        nextEl: "#aboutForecastsNext",
        prevEl: "#aboutForecastsPrev",
      },
      breakpoints: {
        767: {
          slidesPerView: 2,
        },
      },
    });
  }

  // Слайдер для телефонов
  if (document.querySelector("#appPhonesSlider")) {
    const swiper = new Swiper("#appPhonesSlider", {
      slidesPerView: 3,
      spaceBetween: 0,
      navigation: {
        nextEl: "#appPhonesNext",
        prevEl: "#appPhonesPrev",
      },
    });
  }

  const quoteSlider = document.querySelector("#quoteSlider");

  if (quoteSlider) {
    const swiper = new Swiper("#quoteSlider", {
      slidesPerView: 3,
      spaceBetween: 15,
      loop: true,
      loopAdditionalSlides: 3,
      navigation: {
        nextEl: "#quoteNextBtn",
        prevEl: "#quotePrevBtn",
      },
    });

    if (window.innerWidth < 768) {
      swiper.destroy(true, true);
    }
  }

  const licensesSlider = document.querySelector("#licensesSlider");

  if (licensesSlider) {
    const swiper = new Swiper("#licensesSlider", {
      slidesPerView: 1.13,
      spaceBetween: 12,
      loop: false,
      navigation: {
        nextEl: "#licensesNextBtn",
        prevEl: "#licensesPrevBtn",
      },
      breakpoints: {
        // when window width is >= 767px
        767: {
          slidesPerView: 2.2,
        },
        // when window width is >= 1199px
        1199: {
          slidesPerView: 2.67,
        },
      },
    });
  }
});

$(document).on("as_complete", document, function (e, d) {
  // слайдер бонусов
  const bonusesSlider = document.querySelector("#bonusesSlider");

  if (bonusesSlider) {
    const swiper = new Swiper("#bonusesSlider", {
      slidesPerView: 1.62,
      spaceBetween: 8,
      loop: false,
      navigation: {
        nextEl: "#bonusesNextBtn",
        prevEl: "#bonusesPrevBtn",
      },
      breakpoints: {
        // when window width is >= 480px
        480: {
          slidesPerView: 2.5,
        },
        // when window width is >= 576px
        576: {
          slidesPerView: 3,
        },
        // when window width is >= 767px
        767: {
          slidesPerView: 3.5,
        },
        // when window width is >= 1199px
        1199: {
          slidesPerView: 4,
        },
      },
    });
  }

  // слайдер прогнозов
  const forecastsSlider = document.querySelector("#forecastsSlider");

  if (forecastsSlider) {
    const swiper = new Swiper("#forecastsSlider", {
      slidesPerView: 2,
      spaceBetween: 8,
      loop: false,
      navigation: {
        nextEl: "#forecastsNextBtn",
        prevEl: "#forecastsPrevBtn",
      },
      breakpoints: {
        // when window width is >= 767px
        767: {
          slidesPerView: 3,
        },
        // when window width is >= 1199px
        1199: {
          slidesPerView: 4,
        },
      },
    });
  }
});
